import React, {createContext, useContext} from 'react'
import {createStore, StoreApi, useStore} from 'zustand'
// eslint-disable-next-line no-restricted-imports
import {UserState} from '../../../../code/shared/UserState'

interface UserStateStoreType {
    userState: UserState | undefined
}

type UserStateStore = StoreApi<UserStateStoreType>

export const userStateStore = createStore<UserStateStoreType>(() => ({
    userState: undefined,
}))

const UserStateStoreContext = createContext<UserStateStore | null>(null)

export const useUserStateStore = <T, >(selector: (state: UserStateStoreType) => T) => {
    const store = useContext(UserStateStoreContext)
    if(store === null) throw new Error('UserStateStoreContext.Provider is missing in the component tree')

    return useStore(store, selector)
}

interface UserStateProviderProps {
    children: React.ReactNode
}

// @TODO: Move ClientUserState logic to this UserStateProvider as we refactor all the client to React
export const UserStateProvider = ({children}: UserStateProviderProps) => (
    <UserStateStoreContext.Provider value={userStateStore}>
        {children}
    </UserStateStoreContext.Provider>
)

